module.exports = __webpack_public_path__ + "img/health-guide-radiation.4e1084f5.png";